import {
    CREATE_USER_GROUP_REQUEST,
    CREATE_USER_GROUP_SUCCESS,
    CREATE_USER_GROUP_FAILURE,
    GET_USERS_GROUPS_REQUEST,
    GET_USERS_GROUPS_SUCCESS,
    GET_USERS_GROUPS_FAILURE,
    GET_USER_GROUP_REQUEST,
    GET_USER_GROUP_SUCCESS,
    GET_USER_GROUP_FAILURE,
    CLEAN_USERS_GROUPS,
    CLEAN_USER_GROUP,
    SET_TOTAL_USERS_GROUPS,
    DELETE_USER_GROUP_REQUEST,
    DELETE_USER_GROUP_SUCCESS,
    DELETE_USER_GROUP_FAILURE,
    UPDATE_USER_GROUP_REQUEST,
    UPDATE_USER_GROUP_SUCCESS,
    UPDATE_USER_GROUP_FAILURE,
    SEARCH_MEMBERS_REQUEST,
    SEARCH_MEMBERS_SUCCESS,
    SEARCH_MEMBERS_FAILURE,
    SET_TOTAL_MEMBER_SUGGESTIONS,
    ADD_MEMBER,
    DELETE_MEMBER,
    DELETE_ALL_MEMBERS,
    GROUP_GENERAL_INFORMATION_READY,
    GROUP_EXPRESS_CONFIGURATION_READY,
    GROUP_USERS_CONFIGURATION_READY,
    GET_MUSIC_ON_HOLD_REQUEST,
    GET_MUSIC_ON_HOLD_SUCCESS,
    GET_MUSIC_ON_HOLD_FAILURE,
    SET_MEMBERS,
    SEARCH_DEFAULT_EXTENSION_REQUEST,
    SEARCH_DEFAULT_EXTENSION_SUCCESS,
    SEARCH_DEFAULT_EXTENSION_FAILURE,
    SET_TOTAL_DEFAULT_EXTENSION,
    SET_DEFAULT_EXTENSION
} from './groupsActionTypes';

export const createUserGroupRequest = history => ({
    type: CREATE_USER_GROUP_REQUEST,
    payload: { history }
});

export const createUserGroupSuccess = () => ({ type: CREATE_USER_GROUP_SUCCESS });

export const createUserGroupFailure = () => ({
    type: CREATE_USER_GROUP_FAILURE,
    payload: new Error(),
    error: true
});

export const getUsersGroupsRequest = (total, offset, searchText) => ({
    type: GET_USERS_GROUPS_REQUEST,
    payload: {
        total,
        offset,
        searchText
    }
});

export const getUsersGroupsSuccess = usersGroups => ({
    type: GET_USERS_GROUPS_SUCCESS,
    payload: { usersGroups }
});

export const getUsersGroupsFailure = () => ({
    type: GET_USERS_GROUPS_FAILURE,
    payload: new Error(),
    error: true
});

export const getUserGroupRequest = id => ({
    type: GET_USER_GROUP_REQUEST,
    payload: { id }
});

export const getUserGroupSuccess = userGroup => ({
    type: GET_USER_GROUP_SUCCESS,
    payload: { userGroup }
});

export const getUserGroupFailure = () => ({
    type: GET_USER_GROUP_FAILURE,
    payload: new Error(),
    error: true
});

export const cleanUsersGroups = () => ({ type: CLEAN_USERS_GROUPS });

export const cleanUserGroup = () => ({ type: CLEAN_USER_GROUP });

export const setTotalUsersGroups = total => ({
    type: SET_TOTAL_USERS_GROUPS,
    payload: { total }
});

export const deleteUserGroupRequest = id => ({
    type: DELETE_USER_GROUP_REQUEST,
    payload: { id }
});

export const deleteUserGroupSuccess = id => ({
    type: DELETE_USER_GROUP_SUCCESS,
    payload: { id }
});

export const deleteUserGroupFailure = id => ({
    type: DELETE_USER_GROUP_FAILURE,
    payload: { id }
});

export const updateUserGroupsRequest = (id, history) => ({
    type: UPDATE_USER_GROUP_REQUEST,
    payload: {
        id,
        history
    }
});

export const updateUserGroupsSuccess = () => ({ type: UPDATE_USER_GROUP_SUCCESS });

export const updateUserGroupsFailure = () => ({
    type: UPDATE_USER_GROUP_FAILURE,
    payload: new Error(),
    error: true
});

export const searchMembersRequest = (total, offset, searchText) => ({
    type: SEARCH_MEMBERS_REQUEST,
    payload: {
        total,
        offset,
        searchText
    }
});

export const searchMembersSuccess = members => ({
    type: SEARCH_MEMBERS_SUCCESS,
    payload: { members }
});

export const searchMembersFailure = () => ({
    type: SEARCH_MEMBERS_FAILURE,
    payload: new Error(),
    error: true
});

export const setTotalMemberSuggestions = total => ({
    type: SET_TOTAL_MEMBER_SUGGESTIONS,
    payload: { total }
});

export const addMember = member => ({
    type: ADD_MEMBER,
    payload: { member }
});

export const deleteMember = id => ({
    type: DELETE_MEMBER,
    payload: { id }
});

export const deleteAllMembers = () => ({ type: DELETE_ALL_MEMBERS });

export const groupGeneralInformationReady = (status, data) => ({
    type: GROUP_GENERAL_INFORMATION_READY,
    payload: {
        status,
        data
    }
});

export const groupExpressConfigurationReady = (status, data) => ({
    type: GROUP_EXPRESS_CONFIGURATION_READY,
    payload: {
        status,
        data
    }
});

export const groupUsersConfigurationReady = (status, data) => ({
    type: GROUP_USERS_CONFIGURATION_READY,
    payload: {
        status,
        data
    }
});

export const getMusicOnHoldRequest = () => ({ type: GET_MUSIC_ON_HOLD_REQUEST });

export const getMusicOnHoldSuccess = MusicOnHold => ({
    type: GET_MUSIC_ON_HOLD_SUCCESS,
    payload: { MusicOnHold }
});

export const getMusicOnHoldFailure = () => ({
    type: GET_MUSIC_ON_HOLD_FAILURE,
    payload: new Error(),
    error: true
});

export const setMembers = members => ({
    type: SET_MEMBERS,
    payload: { members }
});

export const searchDefaultExtensionRequest = (total, offset, searchText) => ({
    type: SEARCH_DEFAULT_EXTENSION_REQUEST,
    payload: {
        total,
        offset,
        searchText
    }
});

export const searchDefaultExtensionSuccess = members => ({
    type: SEARCH_DEFAULT_EXTENSION_SUCCESS,
    payload: { members }
});

export const searchDefaultExtensionFailure = () => ({
    type: SEARCH_DEFAULT_EXTENSION_FAILURE,
    payload: new Error(),
    error: true
});

export const setTotalDefaultExtensions = total => ({
    type: SET_TOTAL_DEFAULT_EXTENSION,
    payload: { total }
});

export const setDefaultExtension = defaultExtension => ({
    type: SET_DEFAULT_EXTENSION,
    payload: { defaultExtension }
});
